var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "variation-sidebar__wrapper" }, [
    _c("div", {
      staticClass: "variation-sidebar__backdrop",
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.toggleSidebar.apply(null, arguments)
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "variation-sidebar__container" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "aria-label": _vm.$translate("Ceres::Template.closeIcon")
          },
          on: { click: _vm.toggleSidebar }
        },
        [
          _c("svg", { attrs: { height: "26", width: "27" } }, [
            _c("use", {
              attrs: {
                "xlink:href": "#svg_close",
                "xmlns:xlink": "http://www.w3.org/1999/xlink"
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "variation-sidebar__content" },
        [_c("portal-target", { attrs: { name: "sidebar" } })],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }